import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  CategoryScale,
  Legend,
  LineElement,
  PointElement,
  RadialLinearScale,
  Title,
  Tooltip,
} from "chart.js";
import Chart from "chart.js/auto";
import PropTypes from "prop-types";
import {
  getAllMeasurement,
  getMeasurementDateAndValue,
} from "../../../../service-layer/MeasurementService";

import { request } from "../../../../service-layer/AuthenticationService";
const BarComponent = (selectedUser, selectedDescription, selectedDays) => {
  const [user, setUser] = useState(1);
  const [des, setDes] = useState("passi");
  const mockData = {
    labels: ["Label 1", "Label 2", "Label 3"],
    datasets: [
      {
        data: [30, 50, 20, 10, 5], // Sample data values
        backgroundColor: [
          "rgba(255, 99, 132, 0.5)",
          "rgba(54, 162, 235, 0.5)",
          "rgba(255, 206, 86, 0.5)",
          "rgba(75, 192, 192, 0.5)",
          "rgba(153, 102, 255, 0.5)",
          "rgba(255, 159, 64, 0.5)",
        ], // Colors for each section
      },
    ],
  };

  const initialData = {
    labels: [],
    datasets: [
      {
        backgroundColor: [],
        data: [],
      },
    ],
  };
  const [data, setData] = useState([]);
  const [pieData, setPieData] = useState(initialData);
  const getRandomColor = () => {
    // Generate random values for red, green, and blue channels
    const red = Math.floor(Math.random() * 256);
    const green = Math.floor(Math.random() * 256);
    const blue = Math.floor(Math.random() * 256);

    // Generate a random alpha value between 0.1 and 1 (inclusive)
    const alpha = Math.random() * 0.9 + 0.1;

    // Construct the RGBA color string
    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
  };

  useEffect(() => {
    // axios api call
    getMeasurementDateAndValue(
      selectedUser.selectedUser,
      selectedUser.selectedDescription,
      selectedUser.selectedDays,
    ).then((response) => {
      setData(response);
    });
  }, [selectedUser]);

  useEffect(() => {
    let newLabels = [];
    let newBackgroundColors = [];

    for (let i = 0; i < data.length; i++) {
      newBackgroundColors = [...newBackgroundColors, getRandomColor()];
    }
    let newData = [];
    data.forEach((d) => {
      newLabels = [...newLabels, d.date];
      newData = [...newData, d.value];
    });

    newLabels = newLabels.map((label) => {
      const dateTime = new Date(label);
      return dateTime.toLocaleDateString();
    });

    let newPieData = {
      ...pieData,
    };

    // new background
    newPieData = {
      ...newPieData,
      datasets: newPieData.datasets.map((d, index) =>
        index === 0
          ? {
              ...d,
              backgroundColor: newBackgroundColors,
            }
          : d,
      ),
    };

    // new labels
    newPieData = {
      ...newPieData,
      labels: newLabels,
    };

    newPieData = {
      ...newPieData,
      datasets: newPieData.datasets.map((d, index) =>
        index === 0
          ? {
              ...d,
              data: newData,
            }
          : d,
      ),
    };

    setPieData(newPieData);
  }, [data]);

  Chart.register(
    CategoryScale,
    RadialLinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
  );

  const options = {
    responsive: true,
    maintainAspectRatio: false,
  };

  return <Bar data={pieData} options={options} />;
};

BarComponent.propTypes = {
  selectedUser: PropTypes.number,
  selectedDescription: PropTypes.string,
  selectedDays: PropTypes.number,
};
export default BarComponent;
